import { AxiosError } from 'axios';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { reportsApi } from '@/api/index';

export const fetchReportNames = createAsyncThunk(
  'names',
  async (text: string, thunkAPI) => {
    try {
      const response = await reportsApi.getReportNames(text);
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);
